export { ReactComponent as IWarrantyLogoSvg } from 'assets/logo.svg';

export { ReactComponent as AppleLogoSvg } from 'assets/brands/apple.svg';
export { ReactComponent as EmailLogoSvg } from 'assets/brands/email.svg';
export { ReactComponent as FacebookLogoSvg } from 'assets/brands/facebook.svg';
export { ReactComponent as GoogleLogoSvg } from 'assets/brands/google.svg';
export { ReactComponent as StarIconSvg } from 'assets/icons/star.svg';
export { ReactComponent as CopyIconSvg } from 'assets/icons/copy.svg';
export { ReactComponent as AppsIconSvg } from 'assets/icons/apps-icon.svg';
export { ReactComponent as PictureIconSvg } from 'assets/icons/picture-icon.svg';
export { ReactComponent as EyeIconSvg } from 'assets/icons/eye-icon.svg';
export { ReactComponent as TvIconSvg } from 'assets/icons/tv-icon.svg';
export { ReactComponent as CalendarEmptySvg } from 'assets/icons/calendar-empty.svg';
export { ReactComponent as CalendarGraySvg } from 'assets/icons/calendar-gray.svg';
export { ReactComponent as CalendarEmptyGraySvg } from 'assets/icons/calendar-empty-grey.svg';
export { ReactComponent as OpenInSvg } from 'assets/icons/open-in.svg';
export { ReactComponent as SmartphoneSvg } from 'assets/icons/smartphone-icon.svg';
export { ReactComponent as IWRepairerSvg } from 'assets/iW-repairer.svg';
export { ReactComponent as SelectorSvg } from 'assets/icons/selector.svg';
export { ReactComponent as DocumentSvg } from 'assets/icons/document.svg';
export { ReactComponent as ExitSvg } from 'assets/icons/exiticon.svg';
export { ReactComponent as PayNowSvg } from 'assets/icons/paynow.svg';
export { ReactComponent as ConfirmSvg } from 'assets/icons/Confirm.svg';
export { ReactComponent as ChatMenuSvg } from 'assets/icons/chatMenu.svg';
export { ReactComponent as NotificationSvg } from 'assets/icons/Notification.svg';
export { ReactComponent as InfosquareSvg } from 'assets/icons/infosquare.svg';
export { ReactComponent as ChangePasswordSvg } from 'assets/icons/changePassword.svg';
export { ReactComponent as ProfileNotificationSvg } from 'assets/icons/ProfileNotification.svg';
export { ReactComponent as ProfileWalletSvg } from 'assets/icons/ProfileWallet.svg';
export { ReactComponent as ProfileRepairCategoriesSvg } from 'assets/icons/profileRepairCategories.svg';
export { ReactComponent as ProfileRepairLocationSvg } from 'assets/icons/profileRepairLocation.svg';
export { ReactComponent as ProfileAddressSvg } from 'assets/icons/profileAddress.svg';
export { ReactComponent as ProfileBusinessDetailSvg } from 'assets/icons/profileBusinessDetail.svg';
export { ReactComponent as SettingSvg } from 'assets/icons/setting.svg';
export { ReactComponent as AddSvg } from 'assets/icons/add.svg';
export { ReactComponent as HistorySvg } from 'assets/icons/history.svg';
export { ReactComponent as CreditCardSvg } from 'assets/icons/credit-card.svg';
export { ReactComponent as CloseSquare } from 'assets/icons/CloseSquare.svg';
export { ReactComponent as DeleteAccountSvg } from 'assets/icons/deleteUser.svg';
export { ReactComponent as TickSquareSvg } from 'assets/icons/tickSquare.svg';
export { ReactComponent as InfoCircleSvg } from 'assets/icons/infoCircle.svg';
export { ReactComponent as LoginSvg } from 'assets/icons/login.svg';
export { ReactComponent as PdfSvg } from 'assets/icons/pdf.svg';
export { ReactComponent as RobotSvg } from 'assets/icons/robot.svg';
export { ReactComponent as PaperTick } from 'assets/icons/paperTick.svg';
export { ReactComponent as SquareTick } from 'assets/icons/squareTick.svg';
export { ReactComponent as DocumentTick } from 'assets/icons/documentTick.svg';
export { ReactComponent as LocationSvg } from 'assets/icons/location.svg';
export { ReactComponent as RepairerSvg } from 'assets/icons/RepairerIcon.svg';

enum IconLib {
  ADD_NEW = 'add_new',
  ADD_USER = 'add_user',
  APPS = 'apps',
  ARROW_DOWN = 'arrow_down',
  ARROW_DOWN_BOXED = 'arrow_down_boxed',
  ARROW_HEAD_DOWN = 'arrow_head_down',
  ARROW_HEAD_LEFT = 'arrow_head_left',
  ARROW_HEAD_RIGHT = 'arrow_head_right',
  ARROW_HEAD_UP = 'arrow_head_up',
  ARROW_LEFT = 'arrow_left',
  ARROW_LEFT_BOXED = 'arrow_left_boxed',
  ARROW_RIGHT = 'arrow_right',
  ARROW_RIGHT_BOXED = 'arrow_right_boxed',
  ARROW_UP = 'arrow_up',
  ARROW_UP_BOXED = 'arrow_up_boxed',
  BAG = 'bag',
  BAR_CHART_BOXED = 'bar_chart_boxed',
  BELL = 'bell',
  BOOKMARK = 'bookmark',
  BRIEFCASE = 'briefcase',
  CALENDAR = 'calendar',
  CAMERA = 'camera',
  CHAT = 'chat',
  CHEVRON_DOWN = 'chevron_down',
  CHEVRON_DOWN_CIRCLED = 'chevron_down_circled',
  CHEVRON_LEFT = 'chevron_left',
  CHEVRON_LEFT_CIRCLED = 'chevron_left_circled',
  CHEVRON_RIGHT = 'chevron_right',
  CHEVRON_RIGHT_CIRCLED = 'chevron_right_circled',
  CHEVRON_UP = 'chevron_up',
  CHEVRON_UP_CIRCLED = 'chevron_up_circled',
  CLOCK = 'clock',
  CLOCK_SQUARE = 'clock_square',
  CLOSE_PAGE = 'close_page',
  COMPASS = 'compass',
  CROSS = 'cross',
  CROSS_BOXED = 'cross_boxed',
  DOWNLOAD = 'download',
  EDIT = 'edit',
  EDIT_NOTE = 'edit_note',
  ENTER = 'enter',
  ERROR = 'error',
  EXIT = 'exit',
  EYE_HIDDEN = 'eye_hidden',
  EYE_VISIBLE = 'eye_visible',
  FILLED_USER = 'filled_user',
  FILTER = 'filter',
  FOLDER = 'folder',
  GAME_CONTROLLER = 'game_controller',
  HANDBAG = 'handbag',
  HEART = 'heart',
  HISTORY = 'history',
  HOME = 'home',
  INFO = 'info',
  KEY_BOXED = 'key_boxed',
  LINE_GRAPH = 'line_graph',
  LIST = 'list',
  LOCATION_PIN = 'location_pin',
  LOCK = 'lock',
  MAIL = 'mail',
  MENU = 'menu',
  MIC_1 = 'mic_1',
  MIC_2 = 'mic_2',
  MUTE = 'mute',
  NEW_PAGE = 'new_page',
  NOTES = 'notes',
  ORDER = 'order',
  PAGE = 'page',
  PAGE_DOWN_ARROW = 'page_down_arrow',
  PAGE_UP_ARROW = 'page_up_arrow',
  PHONE = 'phone',
  PHONE_CROSS = 'phone_cross',
  PHONE_DISABLED = 'phone_disabled',
  PHONE_RINGING = 'phone_ringing',
  PICTURE_LARGE = 'picture_large',
  PICTURE_SMALL = 'picture_small',
  PIE_CHART = 'pie_chart',
  PLAY = 'play',
  REMOVE_PAGE = 'remove_page',
  REWARD_COUPON = 'reward_coupon',
  SALE = 'sale',
  SCAN = 'scan',
  SEARCH = 'search',
  SEND = 'send',
  SETTINGS = 'settings',
  SHIELD_CROSS = 'shield_cross',
  SHIELD_TICK = 'shield_tick',
  SHOPPING_CART = 'shopping_cart',
  STAR = 'star',
  THREE_DOTS_BOXED = 'three_dots_boxed',
  THREE_DOTS_CIRCLED = 'three_dots_circled',
  THREE_USERS = 'three_users',
  TICK = 'tick',
  TICK_BOXED = 'tick_boxed',
  TICKET = 'ticket',
  TRASH = 'trash',
  TWO_USERS = 'two_users',
  UNLOCK = 'unlock',
  UPLOAD = 'upload',
  USER = 'user',
  VIDEO_CAMERA = 'video_camera',
  VOLUME_DOWN = 'volume_down',
  VOLUME_UP = 'volume_up',
  WALLET = 'wallet',
  WARNING = 'warning',
}

export default IconLib;
